import { MatSnackBar } from '@angular/material';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/service-worker";
import * as i2 from "@angular/material/snack-bar";
import * as i3 from "./localization.service";
var CheckForUpdateService = /** @class */ (function () {
    function CheckForUpdateService(updates, snackbar, languageService) {
        var _this = this;
        this.snackbar = snackbar;
        this.languageService = languageService;
        // Get notified of new deployments.
        updates.available.subscribe(function (evt) {
            // We're using a snackbar to display the message.  If other snackbars are displayed for other reasons
            // those will overwrite this one.  So we'll remember that there is an update and check on regular intervals
            // to see if we need to continue to show this message.
            localStorage.setItem('update-available', 'true');
            _this.showUpdateSnack();
            // Every 30 seconds check if notification needs to be shown again
            if (_this.subs && !_this.subs.closed)
                _this.subs.unsubscribe();
            _this.subs = interval(30000).subscribe(function () {
                _this.showUpdateSnack();
            });
        });
    }
    CheckForUpdateService.prototype.showUpdateSnack = function () {
        var _this = this;
        if (localStorage.getItem('update-available') === 'true') {
            var snack = this.snackbar.open(this.languageService.instant('Global.UpdateAvailable'), this.languageService.instant('Global.Reload'));
            snack.onAction().subscribe(function () {
                _this.subs.unsubscribe();
                localStorage.setItem('update-available', 'false');
                window.location.reload();
            });
        }
    };
    CheckForUpdateService.ngInjectableDef = i0.defineInjectable({ factory: function CheckForUpdateService_Factory() { return new CheckForUpdateService(i0.inject(i1.SwUpdate), i0.inject(i2.MatSnackBar), i0.inject(i3.LocalizationService)); }, token: CheckForUpdateService, providedIn: "root" });
    return CheckForUpdateService;
}());
export { CheckForUpdateService };
